'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3,
    _t4,
    _t5;

import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import { IconHeader } from './MON491FeatureModal/IconHeader';
import { useSelector } from 'react-redux';
import { currentSkuIdForProductSelector, billingNameKeySelector } from '../../selectors/ProductsSelectors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import UIImage from 'UIComponents/image/UIImage';
import { getLocalizedImages } from './MON491FeatureModal/getLocalizedImages';
import H4 from 'UIComponents/elements/headings/H4';
import breakpoint from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
import H5 from 'UIComponents/elements/headings/H5';
import I18n from 'I18n';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
const StyledUITile = styled(UITile).withConfig({
  displayName: "MON570FeatureCard__StyledUITile",
  componentId: "kifo9b-0"
})(["width:100%;"]);
const StyledTileSection = styled(UITileSection).withConfig({
  displayName: "MON570FeatureCard__StyledTileSection",
  componentId: "kifo9b-1"
})(["margin:auto;padding:0 32px;max-width:", ";", ";"], props => props.compact ? '1400px' : undefined, breakpoint.sd(_t || (_t = _`
    padding: 0 32px;
  `)));
const ContentContainer = styled(UIFlex).withConfig({
  displayName: "MON570FeatureCard__ContentContainer",
  componentId: "kifo9b-2"
})(["", ";"], breakpoint.mon491(_t2 || (_t2 = _`
    flex-direction: column;
    text-align: center;
  `)));
const TextContainer = styled.div.withConfig({
  displayName: "MON570FeatureCard__TextContainer",
  componentId: "kifo9b-3"
})(["margin:30px 0;", ";"], breakpoint.sd(_t3 || (_t3 = _`
    margin: 20px 0;
  `)));
const HeaderWrapper = styled(H5).withConfig({
  displayName: "MON570FeatureCard__HeaderWrapper",
  componentId: "kifo9b-4"
})(["text-align:left;", ";"], breakpoint.mon491(_t4 || (_t4 = _`
    text-align: center;
  `)));
const StyledImage = styled(props => {
  const rest = _objectWithoutPropertiesLoose(props, ["compact"]);

  return /*#__PURE__*/_jsx(UIImage, Object.assign({}, rest));
}).withConfig({
  displayName: "MON570FeatureCard__StyledImage",
  componentId: "kifo9b-5"
})(["width:100%;max-width:", " !important;", ";"], props => !props.compact ? '200px' : '250px', breakpoint.sd(_t5 || (_t5 = _`
    max-width: 250px !important;
  `)));

const MON570FeatureCard = ({
  className,
  feature,
  productLine,
  productLevel,
  onClick,
  compact
}) => {
  const billingNameKey = useSelector(reduxState => billingNameKeySelector(reduxState, {
    skuId: currentSkuIdForProductSelector(reduxState, {
      productLine,
      productLevel
    })
  }));
  const [imageSrc] = getLocalizedImages(feature);
  return /*#__PURE__*/_jsx(StyledUITile, {
    className: `m-top-5 ${className}`,
    children: /*#__PURE__*/_jsx(StyledTileSection, {
      compact: compact,
      children: /*#__PURE__*/_jsxs(ContentContainer, {
        align: "center",
        justify: "start",
        children: [/*#__PURE__*/_jsx(StyledImage, {
          compact: compact,
          className: "m-y-4 m-right-7",
          src: imageSrc,
          style: {
            boxShadow: I18n.lang !== 'en' && I18n.lang !== 'nl' && `2px 2px 5px 3px ${GREAT_WHITE}`
          }
        }), /*#__PURE__*/_jsxs(TextContainer, {
          children: [/*#__PURE__*/_jsx(IconHeader, {
            WrapperComponent: HeaderWrapper,
            feature: feature,
            billingNameKey: billingNameKey,
            productLine: productLine,
            width: "20px"
          }), /*#__PURE__*/_jsx(H4, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `mon491FeatureModal.${feature}.header`
            })
          }), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `mon491FeatureModal.${feature}.subheader`
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            onClick: onClick,
            use: "tertiary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `mon570.learn.${feature}`
            })
          })]
        })]
      })
    })
  });
};

export default MON570FeatureCard;